module.exports = __webpack_public_path__ + "img/QRCodegzh.ca8c3f2e.png";